import { Typography } from '@material-ui/core'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import { Skeleton } from '@material-ui/lab'

import { useStyles } from './styles'

interface ReportIssuesProps {
  report?: {
    issues: Array<{ description: string }>
  } | null
}

export function ReportIssues({ report }: ReportIssuesProps) {
  const classes = useStyles()

  if (!report) {
    return (
      <Skeleton
        role='progressbar'
        width={'100%'}
        height={32}
        variant='rect'
        style={{ margin: '14px 0 12px', borderRadius: 4 }}
      />
    )
  }

  return (
    <div className={classes.container}>
      <ReportProblemOutlinedIcon />
      <Typography>Atenção:</Typography>

      <ul className={classes.list}>
        {report.issues.map((issue, index) => (
          <Typography key={index} component={'li'}>
            {issue.description}
          </Typography>
        ))}
      </ul>
    </div>
  )
}
